module.exports = __webpack_public_path__ + "img/plant-walk.231808d4.jpg";